import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SlidersHorizontal } from 'lucide-react';
import GenericSelect from '../../components/ui/GenericSelect';
import { PageWrap, FloatingFilters, FilterIcon, Grid } from './styles';
import { useLeaveDashboardApi } from './config/useLeaveDashboardApi';
import { buildLeaveTypeColorMap } from './constants';
import KpiRow from './components/KpiRow';
import TodayOnLeaveCard from './components/TodayOnLeaveCard';
import DepartmentCapacityCard from './components/DepartmentCapacityCard';
import DensityHeatmapCard from './components/DensityHeatmapCard';
import UpcomingTimelineCard from './components/UpcomingTimelineCard';
import ApprovalPipelineCard from './components/ApprovalPipelineCard';
import BalanceHistogramCard from './components/BalanceHistogramCard';
import BurnoutRiskCard from './components/BurnoutRiskCard';
import RiskSignalsCard from './components/RiskSignalsCard';

export default function LeaveDashboardPage() {
  const { t } = useTranslation();
  const {
    filters, setFilters, slices, departments, locations, variations, refetchAll,
  } = useLeaveDashboardApi();

  const typeColors = useMemo(() => buildLeaveTypeColorMap(variations), [variations]);

  return (
    <PageWrap>
      <FloatingFilters data-export-exclude>
        <FilterIcon><SlidersHorizontal size={14} /></FilterIcon>
        <GenericSelect
          options={departments}
          value={filters.departmentId}
          onChange={(value) => setFilters((prev) => ({ ...prev, departmentId: value || null }))}
          placeholder={t('leaveDashboard.filters.allDepartments')}
          size="small"
          direction="top"
        />
        <GenericSelect
          options={locations}
          value={filters.locationId}
          onChange={(value) => setFilters((prev) => ({ ...prev, locationId: value || null }))}
          placeholder={t('leaveDashboard.filters.allLocations')}
          size="small"
          direction="top"
        />
      </FloatingFilters>
      <Grid>
        <KpiRow summary={slices.summary} risks={slices.risks} balance={slices.balance} />
        <TodayOnLeaveCard slice={slices.today} typeColors={typeColors} />
        <DepartmentCapacityCard slice={slices.capacity} />
        <DensityHeatmapCard slice={slices.density} filters={filters} typeColors={typeColors} />
        <UpcomingTimelineCard slice={slices.timeline} typeColors={typeColors} />
        <ApprovalPipelineCard slice={slices.pipeline} onApproved={refetchAll} />
        <BalanceHistogramCard slice={slices.balance} />
        <BurnoutRiskCard slice={slices.burnout} />
        <RiskSignalsCard slice={slices.risks} setFilters={setFilters} />
      </Grid>
    </PageWrap>
  );
}
